// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZKzk","footer":"styles_footer__6wIkD","passCodeTooltip":"styles_passCodeTooltip__1JjlL"};